import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ReadMore from '../../components/ReadMore';

const WhoWeAreValue = ({ title, text, imgSrc, imgAlt, id, href, width }) => (

  <Col>
    <Row>
      <Col xs={12} sm={12} md={6} lg={8}>
        <h3 
        id={id}
        tabIndex="-1"
        style={{ textAlign: 'left' }}>
          {title}
        </h3>
        <p style={{ textAlign: 'left', marginTop: 20 }}>
          {text}
        </p>
        <div style={{marginTop: 60, marginBottom: 30}}>
          <ReadMore href={href} />
        </div>
      </Col>
      <Col xs={12} sm={12} md={6} lg={4} style={{
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center'
      }}>
        <img
          src={imgSrc}
          aria-label={imgAlt || ""}
          style={{
            width: '100%',
            height: 'auto'
          }}
        />
      </Col>
    </Row>
  </Col>
)

export default WhoWeAreValue;
